import React, { type ReactNode } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

import { cn } from '../lib/utils';

const containerVariants = tv({
  base: '',
  variants: {
    type: {
      default: 'mb-2',
      page: 'bg-gray-100 mb-4 p-2 mx-auto max-w-7xl sm:px-4 lg:px-6',
      'full-width-page': 'bg-gray-100 mb-4 p-2 mx-auto w-full sm:px-4 lg:px-6'
    }
  },
  defaultVariants: {
    type: 'default'
  }
});

type ContainerVariants = VariantProps<typeof containerVariants>;

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement>, ContainerVariants {
  children?: ReactNode;
  className?: string;
}

function Container({ children, className, type = 'default', ...rest }: ContainerProps) {
  return (
    <div {...rest} className={cn(containerVariants({ type }), className)}>
      {children}
    </div>
  );
}

export { Container, containerVariants };
export type { ContainerProps, ContainerVariants };
